{
  "title": "Abi-Dalzim's Horrid Wilting",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "8th-level necromancy",
  "level": 8,
  "castingTime": "1 action",
  "range": "150 feet",
  "components": "V, S, M (a bit of sponge)",
  "duration": "Instantaneous",
  "description": [
    "You draw the moisture from every creature in a 30-foot cube centered on a point you choose within range. Each creature in that area must make a Constitution saving throw. Constructs and undead aren’t affected, and plants and water elementals make this saving throw with disadvantage. A creature takes 10d8 necrotic damage on a failed save, or half as much damage on a successful one."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
